import { createHttpLink } from '@apollo/client'
import { onError } from '@apollo/client/link/error'

const getEnvironmentUri = () => {
  const { location } = window
  const graphQlPath = '/search/graphql'
  const domain = window._env_.resiliaSearchApiURI
  const { protocol } = location
  return `${protocol}//${domain}${graphQlPath}`
}

export const resiliaSearchHttpLink = createHttpLink({
  uri: getEnvironmentUri(),
})

export const resiliaSearchErrorLink = onError(
  ({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) =>
        console.error(
          `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(
            locations
          )}, Path: ${path}`
        )
      )
    }
    if (networkError) {
      console.error(`[Network error]:`, networkError)
    }
  }
)
